import React from 'react';

const ArchiveGraduationCap = ({ size = 1 }: { size?: number }) => (
  <svg
    width={`${size}em`}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_14046_6958)">
      <path
        d="M14.4541 11.9785H12.9541V5.97852H13.7041C14.4998 5.97852 15.2628 6.29459 15.8254 6.85719C16.388 7.4198 16.7041 8.18287 16.7041 8.97852C16.7041 9.17743 16.7831 9.36819 16.9238 9.50885C17.0644 9.6495 17.2552 9.72852 17.4541 9.72852C17.653 9.72852 17.8438 9.6495 17.9844 9.50885C18.1251 9.36819 18.2041 9.17743 18.2041 8.97852C18.2029 7.78542 17.7284 6.64155 16.8847 5.79791C16.0411 4.95426 14.8972 4.47976 13.7041 4.47852H12.9541V2.97852C12.9541 2.7796 12.8751 2.58884 12.7344 2.44819C12.5938 2.30753 12.403 2.22852 12.2041 2.22852C12.0052 2.22852 11.8144 2.30753 11.6738 2.44819C11.5331 2.58884 11.4541 2.7796 11.4541 2.97852V4.47852H10.7041C9.51063 4.47852 8.36603 4.95262 7.52212 5.79654C6.67821 6.64045 6.2041 7.78504 6.2041 8.97852C6.2041 10.172 6.67821 11.3166 7.52212 12.1605C8.36603 13.0044 9.51063 13.4785 10.7041 13.4785H11.4541V19.4785H9.9541C9.15845 19.4785 8.39539 19.1624 7.83278 18.5998C7.27017 18.0372 6.9541 17.2742 6.9541 16.4785C6.9541 16.2796 6.87508 16.0888 6.73443 15.9482C6.59378 15.8075 6.40301 15.7285 6.2041 15.7285C6.00519 15.7285 5.81442 15.8075 5.67377 15.9482C5.53312 16.0888 5.4541 16.2796 5.4541 16.4785C5.45534 17.6716 5.92985 18.8155 6.77349 19.6591C7.61714 20.5028 8.76101 20.9773 9.9541 20.9785H11.4541V22.4785C11.4541 22.6774 11.5331 22.8682 11.6738 23.0088C11.8144 23.1495 12.0052 23.2285 12.2041 23.2285C12.403 23.2285 12.5938 23.1495 12.7344 23.0088C12.8751 22.8682 12.9541 22.6774 12.9541 22.4785V20.9785H14.4541C15.6476 20.9785 16.7922 20.5044 17.6361 19.6605C18.48 18.8166 18.9541 17.672 18.9541 16.4785C18.9541 15.285 18.48 14.1404 17.6361 13.2965C16.7922 12.4526 15.6476 11.9785 14.4541 11.9785ZM10.7041 11.9785C9.90845 11.9785 9.14539 11.6624 8.58278 11.0998C8.02017 10.5372 7.7041 9.77417 7.7041 8.97852C7.7041 8.18287 8.02017 7.4198 8.58278 6.85719C9.14539 6.29459 9.90845 5.97852 10.7041 5.97852H11.4541V11.9785H10.7041ZM14.4541 19.4785H12.9541V13.4785H14.4541C15.2498 13.4785 16.0128 13.7946 16.5754 14.3572C17.138 14.9198 17.4541 15.6829 17.4541 16.4785C17.4541 17.2742 17.138 18.0372 16.5754 18.5998C16.0128 19.1624 15.2498 19.4785 14.4541 19.4785Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_14046_6958"
        x="-4.7959"
        y="-0.271484"
        width="34"
        height="34"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_14046_6958"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14046_6958"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_14046_6958"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_14046_6958"
          result="effect2_dropShadow_14046_6958"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_14046_6958"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ArchiveGraduationCap;
